import {gsap} from "gsap";

export default class Loader {
    constructor() {
        this.loader = document.getElementById("loader");
        this.loaderLogo = document.getElementById("loaderLogo");
        this.headerLogo = document.getElementById("siteLogo");
        this.path = this.loaderLogo.querySelector("path");
        this.init();
    }

    init() {
        if (!this.loader || !this.loaderLogo || !this.headerLogo) return;

        window.addEventListener("load", () => {
            this.animateIntro();
        });
    }


    animateIntro() {
        const pathLength = this.path.getTotalLength();

        // Prépare le path pour le "draw"
        gsap.set(this.path, {
            strokeDasharray: pathLength,
            strokeDashoffset: pathLength
        });

        // Récupère position finale du logo (dans le header)
        const loaderRect = this.loaderLogo.getBoundingClientRect();
        const headerRect = this.headerLogo.getBoundingClientRect();
        const dx = headerRect.left - loaderRect.left;
        const dy = headerRect.top - loaderRect.top;
        const scale = headerRect.width / loaderRect.width;

        // Timeline unique
        const tl = gsap.timeline({
            defaults: { ease: "power2.inOut" },
            onComplete: () => this.dispatchFinishedEvent()
        });

        tl.to(this.loaderLogo, { opacity: 1, duration: 0.3 })
            .to(this.path, {
                strokeDashoffset: 0,
                duration: .7
            })
            .to(this.loaderLogo, {
                x: dx,
                y: dy,
                scale: scale,
                duration: 1.2,
                ease: "power3.inOut"
            })
            .to(this.loader, {
                opacity: 0,
                duration: 0.5,
                ease: "power2.out",
                onComplete: () => {
                    this.loader.remove();
                    this.headerLogo.style.opacity = 1;
                }
            });
    }

    dispatchFinishedEvent() {
        const event = new CustomEvent("loader:finished");
        document.dispatchEvent(event);
        document.querySelector('html').classList.remove('no-scroll');
    }
}
